import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';

export const useGetUnreadMessageCount = (userName: string) => {

    const { data } = useQuery({
        queryKey: ['unread-message-count', userName],
        queryFn: async () => await apiClient.get('communication/unread-message-count') as number,
        refetchInterval: 60000
    });

    return {
        data
    };
};
